'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentStatusLabelView: {
        displayName: 'PaymentStatusLabelView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PaymentStatusLabel/default/PaymentStatusLabelView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PaymentStatusLabelView = _wrapComponent('PaymentStatusLabelView')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PaymentStatusLabelView, _Component);

    function PaymentStatusLabelView() {
        (0, _classCallCheck3.default)(this, PaymentStatusLabelView);
        return (0, _possibleConstructorReturn3.default)(this, (PaymentStatusLabelView.__proto__ || (0, _getPrototypeOf2.default)(PaymentStatusLabelView)).apply(this, arguments));
    }

    (0, _createClass3.default)(PaymentStatusLabelView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                labelText = _props.labelText,
                lang = _props.lang;

            var className = 'label-' + type;
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: className, style: {
                            display: 'inline-block',
                            padding: '.3em .6em .4em', fontSize: '75%', fontWeight: 'bold', lineHeight: 1,
                            color: '#fff', textAlign: 'center',
                            verticalAlign: 'baseline',
                            borderRadius: '.25em' } },
                    lang[labelText]
                )
            );
        }
    }]);
    return PaymentStatusLabelView;
}(_react2.Component), _class2.propType = {
    type: _propTypes2.default.string.isRequired,
    labelText: _propTypes2.default.string.isRequired,
    lang: _propTypes2.default.object.isRequired
}, _temp)) || _class));

exports.default = PaymentStatusLabelView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentStatusLabel/default/PaymentStatusLabelView.jsx
// module id = 1734
// module chunks = 0